(() => {
  const accordionButtons = document.querySelectorAll(
    '.main-page-title + .rte [role="button"][aria-controls]'
  );

  accordionButtons.forEach((button) => {
    const contentId = button.getAttribute('aria-controls');
    const content = contentId ? document.getElementById(contentId) : null;

    if (!content || button.dataset.magcheerAccordion === 'true') return;

    button.dataset.magcheerAccordion = 'true';
    button.setAttribute('tabindex', button.getAttribute('tabindex') || '0');
    button.setAttribute('aria-expanded', 'false');
    content.hidden = true;

    const toggle = () => {
      const isOpen = button.getAttribute('aria-expanded') === 'true';

      button.setAttribute('aria-expanded', String(!isOpen));
      content.hidden = isOpen;
    };

    button.addEventListener('click', toggle);
    button.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;

      event.preventDefault();
      toggle();
    });
  });
})();
